import { ITransformParams } from "../types/transform_params.js";
import { Easing, TransformBase, TransformType } from "./transform_base.js";
import { Transformable } from "./transformable.js";

export class TransformOpacity<T extends Transformable> extends TransformBase
{
  private readonly target: T;
  private from: number;
  private dest: number;

  constructor(
    target: T,

    is_important: boolean,
    from: number | null,
    dest: number,

    anim_start_time: number,
    duration_in_ms: number,

    optional_params: ITransformParams = {}
  )
  {
    super(
      TransformType.Opacity,
      anim_start_time,
      duration_in_ms,
      is_important,
      optional_params
    );

    this.target = target;

    this.from = from ?? ( is_important ? 0.0 : 1.0 );
    this.dest = is_important ? Math.max( 0, Math.min( 1, dest ) ) : Math.max( 0, dest );
  }

  protected getTarget(): any { return this.target; }

  protected initImportant(): void
  {
    if ( this.isImportant() && this.from === 0.0 )
    {
      this.from = this.target.getOpacityImportant();
    }
  }

  protected onUpdateTransform( eased: number ): void
  {
    const value = this.lerp( this.from, this.dest, eased );

    if ( this.isImportant() )
    {
      this.target.setOpacity( value );
    } else
    {
      this.target.addToOpacity( value );
    }
  }

  private lerp( a: number, b: number, t: number ): number
  {
    return a + ( b - a ) * t;
  }

  public startValue(): number { return this.from; }
  public destValue(): number { return this.dest; }

  public setDestination( value: number ): void
  {
    if ( this.isImportant() )
    {
      this.dest = Math.max( 0, Math.min( 1, value ) );
    } else
    {
      this.dest = Math.max( 0, value );
    }
  }

  public toStrTransform(): string
  {
    const type = this.isImportant() ? "Important" : "Additive";
    return `TransformOpacity(${type})   from ${this.from}  to ${this.dest}`;
  }
}
